import { cilX } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CButton } from '@coreui/react';
import React from 'react';

interface ClearFiltersButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  fullWidth?: boolean;
}

export const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
  fullWidth = true,
}) => {
  return (
    <CButton
      color="secondary"
      variant="outline"
      disabled={disabled}
      onClick={onClick}
      className={`${fullWidth ? 'w-100' : ''} ${className}`}
    >
      <CIcon icon={cilX} className="me-1" />
      Clear Filters
    </CButton>
  );
};
